var exports = {
  "iV": "automatedComment__HTpuBI",
  "K": "automatedComment__headerContainer__dWR42D",
  "$e": "automatedComment__bodyContainer__b1nmhE",
  "sP": "automatedComment__body__AlBj0F",
  "XF": "automatedComment__content__B_OcSK",
  "ss": "automatedComment__title__Z_yn87",
  "LY": "automatedComment__message__toDg44",
};

module.exports = exports;
